import React from 'react';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import { currencyDisplay } from '../../_utils';

function ProductGridPrice(props) {
    const { item } = props;
    /* This should be fixed later */
    const { locale = 'en_AU' } = window;
    /* This should be fixed later */
    const { ProdType, SalePrice, RRP, IsSale, CurrencyFormat, CurrencyDisplayCode } = item;

    if (typeof SalePrice == 'undefined' || SalePrice == null) {
        return '';
    }

    if (ProdType === 'ID') {
        return (
            <React.Fragment>
                <span className='product-grid__price product-grid__price--from'>
                    <LocalizedMessage id={'FROM'} />
                </span>
                <span className='product-grid__price product-grid__price--new'>
                    {currencyDisplay(SalePrice, CurrencyDisplayCode, CurrencyFormat, locale)}
                </span>
            </React.Fragment>
        );
    } else if (ProdType === 'RP' && IsSale) {
        return (
            <React.Fragment>
                <span className='product-grid__price product-grid__price--old'>
                    {currencyDisplay(RRP, CurrencyDisplayCode, CurrencyFormat, locale)}
                </span>
                <span className='product-grid__price product-grid__price--new'>
                    {currencyDisplay(SalePrice, CurrencyDisplayCode, CurrencyFormat, locale)}
                </span>
            </React.Fragment>
        );
    } else {
        // this is in-store product
        return (
            <React.Fragment>
                <span className='product-grid__price'>
                    {currencyDisplay(SalePrice, CurrencyDisplayCode, CurrencyFormat, locale)}
                </span>
            </React.Fragment>
        );
    }
}

// default props
ProductGridPrice.defaultProps = {
    item: {},
};
// validate props
ProductGridPrice.propTypes = {
    item: PropTypes.any.isRequired,
};

export default ProductGridPrice;
